import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { Splash } from "../components/layout/Splash";

// 認証ガード。未認証なら /login へ退避し、元の遷移先を state.from に保持して
// サインイン後に戻す。セッション復元中（ready=false）はスプラッシュを出す。
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <Splash />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
